import React, { useState } from 'react';
import { SegmentedControl } from '../../../../CommonComponents/OPL/SegmentedControl/SegmentedControl';
import { PieChart } from '../PieChart/PieChart';
import { StackedBarChart } from '../StackedBarChart/StackedBarChart';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { AssetAllocation } from '../../../../CommonUtils/getAssetColors';
import { WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

const ComponentMap = {
  Chart: PieChart,
  List: StackedBarChart,
};

interface Props extends WrapperProps {
  assetAllocation: AssetAllocation[];
}
export const ChartsContainer: React.FC<Props> = ({ assetAllocation }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const tabNameList = Object.keys(ComponentMap);

  const Component = ComponentMap[tabNameList[tabIndex]];

  return (
    <>
      <Box display="flex" justifyContent="center">
        <Box width={150}>
          <SegmentedControl
            id="ChartType"
            values={tabNameList}
            selectedIndex={tabIndex}
            onChange={setTabIndex}
            ariaLabel="Select chart type"
          />
        </Box>
      </Box>

      <Component assetAllocation={assetAllocation} />
    </>
  );
};
